import './hookRoute';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import Oidc from 'oidc-client';
import global from './utils/global';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import VueAMap from 'vue-amap';
import { lazyAMapApiLoaderInstance } from 'vue-amap';

import SvgIcon from '@/components/SvgIcon/index.vue';

import VueClipboard from 'vue-clipboard2';

Vue.config.productionTip = false;

Vue.use(ElementUI);

Vue.use(VueClipboard);

const oidcConfig = {
  userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
  // authority: 'http://localhost:5000',
  authority: global.AUTH_URL, // 'http://auth.easysmart.cn',
  client_id: 'API',
  // redirect_uri: 'http://localhost:8080/static/callback.html',
  // post_logout_redirect_uri: 'http://localhost:8080/index.html',
  // slient_redirect_uri: 'http://localhost:5000/silent-renew.html',
  redirect_uri: global.BASE_URL + '/static/callback_front.html', // 'http://esmap.easysmart.cn/static/callback.html',
  post_logout_redirect_uri: global.BASE_URL, //  + '/index.html', // 'http://esmap.easysmart.cn/index.html',
  slient_redirect_uri: global.BASE_URL + '/static/silent-renew.html', // 'http://esmap.easysmart.cn/static/silent-renew.html',
  response_type: 'id_token token',
  scope: 'openid ESResourceAPI profile',
  loadUserInfo: true,
};
Oidc.Log.logger = console;
(window as any).mgr = new Oidc.UserManager(oidcConfig);

setTimeout( () => {
  localStorage.removeItem('_AMap_raster');
  Vue.use(VueAMap);
  }, 0);

VueAMap.initAMapApiLoader({
  key: 'ab1bb25ce8dd70331824a8ad96dfaaae',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType'
  , 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geocoder', 'AMap.Polyline'],
  v: '1.4.4',
});
// lazyAMapApiLoaderInstance.load().then( () => {
//   // localStorage.removeItem('_ AMap_raster');
//   Vue.use(VueAMap);
//   });


Vue.component('svg-icon', SvgIcon);

const req = require.context('./icons/svg', false, /\.svg$/);
const requireAll = (requireContext: any) => requireContext.keys().map(requireContext);
requireAll(req);


new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
